import { render, staticRenderFns } from "./RangeSliderNewHandle.vue?vue&type=template&id=2d84c854&scoped=true&"
import script from "./RangeSliderNewHandle.vue?vue&type=script&lang=js&"
export * from "./RangeSliderNewHandle.vue?vue&type=script&lang=js&"
import style0 from "./RangeSliderNewHandle.vue?vue&type=style&index=0&id=2d84c854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84c854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d84c854')) {
      api.createRecord('2d84c854', component.options)
    } else {
      api.reload('2d84c854', component.options)
    }
    module.hot.accept("./RangeSliderNewHandle.vue?vue&type=template&id=2d84c854&scoped=true&", function () {
      api.rerender('2d84c854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ageCategoriesRangeSlider/RangeSliderNewHandle.vue"
export default component.exports